var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalleadicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 16,
    viewBox: "0 0 28 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 9.12891C22.37 10.0589 23.33 11.3189 23.33 12.9989V15.9989H26.33C26.88 15.9989 27.33 15.5489 27.33 14.9989V12.9989C27.33 10.8189 23.76 9.52891 21 9.12891Z",
    fill: "#6622CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.32812 9.12891C4.95812 10.0589 3.99813 11.3189 3.99813 12.9989V15.9989H0.998125C0.448125 15.9989 -0.00187492 15.5489 -0.00187492 14.9989V12.9989C-0.00187492 10.8189 3.56813 9.52891 6.32812 9.12891Z",
    fill: "#6622CC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3281 8C15.5373 8 17.3281 6.20914 17.3281 4C17.3281 1.79086 15.5373 0 13.3281 0C11.119 0 9.32812 1.79086 9.32812 4C9.32812 6.20914 11.119 8 13.3281 8Z",
    fill: "#6622CC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3281 8C20.5381 8 22.3281 6.21 22.3281 4C22.3281 1.79 20.5381 0 18.3281 0C17.8581 0 17.4181 0.0999998 16.9981 0.24C17.8586 1.30422 18.3281 2.6314 18.3281 4C18.3281 5.3686 17.8586 6.69578 16.9981 7.76C17.4181 7.9 17.8581 8 18.3281 8ZM12.3281 9C9.65812 9 4.32812 10.34 4.32812 13V15C4.32812 15.55 4.77812 16 5.32812 16H19.3281C19.8781 16 20.3281 15.55 20.3281 15V13C20.3281 10.34 14.9981 9 12.3281 9Z",
    fill: "#6622CC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.32812 8C6.11813 8 4.32812 6.21 4.32812 4C4.32812 1.79 6.11813 0 8.32812 0C8.79813 0 9.23812 0.0999998 9.65812 0.24C8.7976 1.30422 8.32816 2.6314 8.32816 4C8.32816 5.3686 8.7976 6.69578 9.65812 7.76C9.23812 7.9 8.79813 8 8.32812 8ZM14.3281 9C16.9981 9 22.3281 10.34 22.3281 13V15C22.3281 15.55 21.8781 16 21.3281 16H7.32812C6.77812 16 6.32812 15.55 6.32812 15V13C6.32812 10.34 11.6581 9 14.3281 9Z",
    fill: "#6622CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalleadicon);
export default __webpack_public_path__ + "static/media/totallead icon.fb17b9bc641d1b259399739856ad404f.svg";
export { ForwardRef as ReactComponent };